import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home.component';
import { LegalComponent } from './legal/legal.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { TermsAndConditionsComponent } from './termsandconditions/termsandconditions.component';

export const router: Routes = [
    {path: '', component: HomeComponent},
    {path: 'privacy', component: PrivacyComponent},
    {path: 'termsandconditions', component: TermsAndConditionsComponent},
    {path: 'legal', component: LegalComponent}
  ];

export const routes: ModuleWithProviders<any> = RouterModule.forChild(router);
